export default __webpack_public_path__ + "static/media/AboutUs.d73d459a.png";